import { __ } from '@wordpress/i18n';
import { useState, useEffect, useRef } from '@wordpress/element';
import {
	Placeholder,
	Button,
	Dashicon,
	Modal,
	TabPanel,
	TabList,
	Tab,
	PanelRow,
	PanelColumn,
	RangeControl,
} from '@wordpress/components';
import InspectorResponsiveLabel from '../inspector-responsive-label';
// import { mediaChange } from '../inspector-responsive-label-2';

// Global media state and event
if ( ! window.__alphaBlocksCurrentMedia ) {
	window.__alphaBlocksCurrentMedia = 'desktop';
}

const InspectorResponsiveRangeControl = ( props ) => {
	const {
		label,
		value = {},
		onChange = () => {},
		min,
		max,
		availableUnits = [ 'px', 'em', '%' ],
		availableMedia = [ 'desktop', 'tablet', 'mobile' ],
	} = props;
	const [ rowsGap, setRowsGap ] = useState( 2 );
	const [ currentMedia, setCurrentMedia ] = useState( 'desktop' );
	const [ currentValue, setCurrentValue ] = useState( value?.desktop?.val );
	const [ currentUnit, setCurrentUnit ] = useState( 'px' );

	const makeUnitObj = ( unit ) => ( {
		key: unit?.key ?? unit,
		name: unit?.name ?? unit,
	} );
	const getUnit = ( unit ) => unit?.key ?? unit;

	const reSet = () => {
		if ( 'function' === typeof onChange ) {
			// console.log("range control", value,props?.defaultAttributes, {...value, ...props?.defaultAttributes} );
			let currentValue = { ...value, ...props?.defaultAttributes };
			setCurrentMedia( 'desktop' );
			setCurrentUnit( () => ( { key: 'px', value: 'px' } ) );
			setCurrentValue( currentValue?.desktop?.val );
			onChange( { ...props?.defaultAttributes } );
		}
	};

	useEffect( () => {
		onChange( {
			...value,
			[ currentMedia ]: {
				...value?.[ currentMedia ],
				val: currentValue,
				unit: getUnit( currentUnit ),
			},
		} );
	}, [ currentValue, currentUnit ] );

	useEffect( () => {
		if ( currentMedia in value ) {
			// console.log("_currentUnit:, value?.[currentMedia] ", _currentUnit, value?.[currentMedia]);

			let _currentUnit = value?.[ currentMedia ]?.unit;
			setCurrentUnit( makeUnitObj( _currentUnit ) );
			setCurrentValue( value?.[ currentMedia ]?.val );

			onChange( {
				...value,
				[ currentMedia ]: {
					...value?.[ currentMedia ],
					val: value?.[ currentMedia ]?.val,
					unit: getUnit( currentUnit ),
				},
			} );
		} else {
			onChange( {
				...value,
				[ currentMedia ]: {
					...value?.[ currentMedia ],
					val: currentValue,
					unit: getUnit( currentUnit ),
				},
			} );
		}

		// Update the window Size and work like label 2
		// mediaChange(currentMedia)
	}, [ currentMedia ] );

	return (
		<div>
			<InspectorResponsiveLabel
				label={ label ?? 'Default Label' }
				value={ value }
				currentMedia={ currentMedia }
				setCurrentMedia={ setCurrentMedia }
				currentUnit={ currentUnit }
				setCurrentUnit={ setCurrentUnit }
				onReset={ () => reSet() }
				unites={ availableUnits }
				availableMedia={ availableMedia }
				defaultUnit="px"
			/>
			<RangeControl
				__next40pxDefaultSize
				__nextHasNoMarginBottom
				initialPosition={ min }
				label=""
				value={ currentValue }
				onChange={ ( val ) => setCurrentValue( val ) }
				{ ...( min && { min: min } ) }
				{ ...( max && { max: max } ) }
			/>
		</div>
	);
};

export default InspectorResponsiveRangeControl;
